import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Layout } from '@/layout/Layout';
import { OPEN_FOLDER_ON_ENTER_APP } from '@/constants/sessionKeys';

export default function Landing() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleStart = () => {
    sessionStorage.setItem(OPEN_FOLDER_ON_ENTER_APP, '1');
    navigate('/app');
  };

  return (
    <Layout hideHeaderButtons>
      <main className="landing-main">
        <section className="landing-card">
          <p className="landing-kicker">LensSift</p>
          <h1 className="landing-title">{t('landing-title')}</h1>
          <p className="landing-subtitle">{t('landing-subtitle')}</p>
          <p className="landing-description">{t('landing-description')}</p>

          <button className="btn-primary landing-start" onClick={handleStart}>
            {t('landing-start-button')}
          </button>

          <ul className="landing-points">
            <li>{t('landing-point-grid')}</li>
            <li>{t('landing-point-keyboard')}</li>
            <li>{t('landing-point-copy')}</li>
          </ul>

          <section className="landing-section">
            <h2 className="landing-section-title">{t('landing-steps-title')}</h2>
            <ol className="landing-steps">
              <li>{t('landing-step-open')}</li>
              <li>{t('landing-step-pick')}</li>
              <li>{t('landing-step-copy')}</li>
            </ol>
          </section>

          <section className="landing-section">
            <h2 className="landing-section-title">{t('landing-trust-title')}</h2>
            <ul className="landing-trust-list">
              <li>{t('landing-trust-no-upload')}</li>
              <li>{t('landing-trust-local')}</li>
              <li>{t('landing-trust-privacy')}</li>
            </ul>
          </section>
        </section>
      </main>
    </Layout>
  );
}
